import { CommonModule } from '@angular/common';
import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserVerificationCodeType } from '@models/sign-up/user-verification-code-type.enum';
import { User } from '@models/users/user.model';
import { CodeInputComponent } from '@modules/shared/components/code-input/code-input.component';
import { CountdownFormatPipe } from '@modules/sign-up/components/verify-phone-step/verify-phone-step.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@services/auth/auth.service';
import { FormsModules } from '@utils/shared-modules';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-otp-verification',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModules,
    CodeInputComponent,
    CountdownFormatPipe,
  ],
  templateUrl: './otp-verification.dialog.html',
  styleUrl: './otp-verification.dialog.scss',
})
export class OtpVerificationDialog {
  resendInProgress = false;
  isWrongCode = false;
  resendSuccess = false;
  isResendInCooldown = false;

  timeLeft = 90;
  interval: any;

  userId?: number;
  email?: string;

  @ViewChild('codeInput') codeInput!: CodeInputComponent;

  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<OtpVerificationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.userId = data?.userId;
      this.email = data?.email;
    }

    this.startTimer();
    this.isResendInCooldown = true;
    this.resendSuccess = true;
    setTimeout(() => (this.resendSuccess = false), 2000);
  }

  onCodeChanged(code: string) {
    this.isWrongCode = false;
  }

  onCodeCompleted(code: string) {
    this.authService.verifyUserViaCode(code).subscribe({
      next: () => {
        this.dialogRef.close({ logUser: true });
      },
      error: () => {
        this.isWrongCode = true;
      },
    });
  }

  resendEmail() {
    if (!this.userId) {
      return;
    }

    if (this.isResendInCooldown || this.resendInProgress) {
      return;
    }

    this.resendInProgress = true;

    this.authService
      .resendVerificationCode(this.userId, UserVerificationCodeType.EMAIL)
      .pipe(finalize(() => (this.resendInProgress = false)))
      .subscribe({
        next: () => {
          this.startTimer();
          this.isResendInCooldown = true;
          this.resendSuccess = true;
          setTimeout(() => (this.resendSuccess = false), 2000);
          this.codeInput.reset();
        },
        error: (err) => {
          if (err?.message === 'cooldown time has not passed') {
            this.startTimer();
            this.isResendInCooldown = true;
          }
        },
      });
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        clearInterval(this.interval);
        this.timeLeft = 90;
        this.isResendInCooldown = false;
      }
    }, 1000);
  }

  change() {
    this.dialogRef.close({ change: true });
  }

  close() {
    this.dialogRef.close();
  }
}
